import React, { Component } from 'react';
import Home from './components/Home'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Home />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js